// RB-MY01-PalmGarden.web/src/components/PlantForm/components/FormSections/Description.tsx
import React from 'react';
import { Box, Typography } from '@mui/material';
import SectionCard from '../SectionCard';
import { FormSectionProps } from '../../types';
import { sectionThemes } from '../../styles';

const Description: React.FC<FormSectionProps> = ({ 
  plant
}) => {
  return (
    <SectionCard 
      title="Plant Description" 
      icon={<i className={sectionThemes.description.iconName} style={{ marginRight: '8px' }} />}
      theme={{ color: sectionThemes.description.color }}
    >
      <Box sx={{ p: 2 }}>
        <Typography>
          Description section is under construction.
        </Typography>
      </Box>
    </SectionCard>
  );
};

export default React.memo(Description);
